import React, { useState, useRef, useEffect } from 'react';
import Link from 'next/link';
import Dropdown from '../Shared/utils/Dropdown';
import Transition from '../Shared/utils/Transition';
import HeaderProfile from '../HeaderProfileBox/HeaderProfile3';
import StoreButton from './StoreButton';
import SearchBox from '../SearchBox/SearchBox';
import CustomSearchBox from '../SearchBox/CustomSearchBox';
import axios from 'axios';
import { useRouter } from 'next/dist/client/router';
import { TYPE_CONSTANT } from '../../constant/Web_constant';
import Add_listing_button from '../Shared/Buttons/Add_listing_button';
import { Menubar_text } from '../../constant/Translation/Heading';
import { getCookie } from 'cookies-next';
import SearchBox4 from '../SearchBox/SearchBox4';
import Notifications2 from '../NotificationsButton/Notifications2';
import Notifications4 from '../NotificationsButton/Notification4';
import Language_switch from '../HeaderButton/Language_switch_button';
import Language_switch2 from '../HeaderButton/Language_switch_button2';
import HeaderProfile5 from '../HeaderProfileBox/HeaderProfile5';
import { myStore } from '../../store/feature/storeSlice';
import {
  categories,
  categorySelector,
} from '../../store/feature/categorySlice';
import { useDispatch, useSelector } from 'react-redux';
import { getNotifications } from '../../store/feature/notificationSlice';
import { slug as SlugChecker } from 'github-slugger';

function Header12() {
  const dispatch = useDispatch();

  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [top, setTop] = useState(true);
  const router = useRouter();
  const trigger = useRef(null);
  const mobileNav = useRef(null);

  // close the mobile menu on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!mobileNav.current || !trigger.current) return;
      if (
        !mobileNavOpen ||
        mobileNav.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setMobileNavOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close the mobile menu if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!mobileNavOpen || keyCode !== 27) return;
      setMobileNavOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  // detect whether user has scrolled the page down by 10px
  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true);
    };
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [top]);

  const [logo, setLogo] = useState(localStorage.getItem('logo'));
  const [login, setLogin] = useState(localStorage.getItem('login'));

  // Store Fetch and categories fetch
  let userDetails = JSON.parse(localStorage.getItem('user_details'));
  useEffect(() => {
    if (localStorage.getItem(`${TYPE_CONSTANT.DOMAIN}_auth_key`)) {
      dispatch(
        myStore({
          prams: {
            page: 1,
            type: 'accounts',
            user_id: userDetails.id,
          },
        })
      );
    }
    dispatch(
      categories({
        prams: { parent: 0, type: 'listings' },
      })
    );
  }, []);

  //Notifications Effect
  useEffect(() => {
    if (localStorage.getItem(`${TYPE_CONSTANT.DOMAIN}_auth_key`)) {
      dispatch(
        getNotifications({
          page: 1,
        })
      );
    }
  }, [router]);

  //
  const { all_categories } = useSelector(categorySelector);

  return (
    <header
      className={`sticky top-0 w-full z-40 md:bg-opacity-90 transition duration-300 ease-in-out bg-white  ${
        !top && 'bg-white  blur  shadow-lg'
      }`}
    >
      <div className=" max-w-[1140px] relative   mx-auto px-4 py-[14px]">
        <div
          className="flex items-center justify-between  "
          style={{
            height: `calc(${
              TYPE_CONSTANT.GENERAL_CONFIGS?.logo_height ?? 50
            }px  )`,
          }}
        >
          {/* Site branding */}
          <div className=" md:flex-shrink-0 ltr:mr-4 rtl:ml-4">
            {/* Logo */}
            <Link href="/">
              <div className="block">
                {logo && (
                  <Link href="/" passHref={true}>
                    <a className=" flex items-center   relative cursor-pointer ">
                      <img
                        src={logo}
                        style={{
                          height: `${
                            TYPE_CONSTANT.GENERAL_CONFIGS?.logo_height ?? 50
                          }px`,
                          width: `${TYPE_CONSTANT.GENERAL_CONFIGS?.logo_width}px`,
                          objectFit:
                            TYPE_CONSTANT.GENERAL_CONFIGS?.logo_object_fit ??
                            'contain',
                        }}
                        alt="logo"
                      />
                    </a>
                  </Link>
                )}
              </div>
            </Link>
          </div>

          {/* Desktop navigation */}

          <div
            className=" hidden  flex-grow md:flex   justify-start   items-center gap-2"
            id={'header_nav_items'}
          >
            <div className="  flex-grow ">
              <SearchBox4 />
            </div>
            <div className="flex-none">
              <Language_switch2 />
            </div>
            <div className="flex-none">
              <Notifications4 />
            </div>
            <div className=" h-full flex-none" id={'header_cart_items'}>
              <Link
                href={
                  getCookie(`${TYPE_CONSTANT.DOMAIN}_login`)
                    ? '/checkout'
                    : '/sign-in?to=/checkout'
                }
              >
                <a className="   h-full aspect-1 p-3 flex items-center justify-center rounded-full  transition duration-400   bg-[#22222213]  ">
                  <svg
                    width="19"
                    height="21"
                    viewBox="0 0 19 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.5 13C18.4978 12.3997 18.3155 11.8139 17.9768 11.3183C17.6381 10.8227 17.1585 10.4401 16.6 10.22L18.47 3.22001C18.5091 3.07093 18.5131 2.91484 18.4819 2.76392C18.4507 2.61301 18.385 2.47135 18.29 2.35001C18.1929 2.23632 18.0715 2.14585 17.9348 2.08528C17.798 2.02471 17.6495 1.99557 17.5 2.00001H3.8L3.47 0.74001C3.41263 0.52692 3.28638 0.338794 3.11093 0.204945C2.93547 0.0710953 2.72068 -0.000958872 2.5 9.63738e-06H0.5V2.00001H1.73L4.21 11.26C4.2686 11.4782 4.39934 11.6701 4.58092 11.8044C4.76251 11.9388 4.98424 12.0077 5.21 12H15.5C15.7652 12 16.0196 12.1054 16.2071 12.2929C16.3946 12.4804 16.5 12.7348 16.5 13C16.5 13.2652 16.3946 13.5196 16.2071 13.7071C16.0196 13.8947 15.7652 14 15.5 14H2.5C2.23478 14 1.98043 14.1054 1.79289 14.2929C1.60536 14.4804 1.5 14.7348 1.5 15C1.5 15.2652 1.60536 15.5196 1.79289 15.7071C1.98043 15.8947 2.23478 16 2.5 16H3.68C3.51554 16.4531 3.46269 16.9392 3.52593 17.4171C3.58917 17.895 3.76665 18.3506 4.04332 18.7454C4.31999 19.1401 4.68772 19.4624 5.11535 19.6849C5.54299 19.9074 6.01795 20.0235 6.5 20.0235C6.98205 20.0235 7.45701 19.9074 7.88465 19.6849C8.31228 19.4624 8.68001 19.1401 8.95668 18.7454C9.23335 18.3506 9.41083 17.895 9.47407 17.4171C9.53731 16.9392 9.48446 16.4531 9.32 16H11.68C11.5303 16.4126 11.4729 16.853 11.512 17.2902C11.551 17.7274 11.6856 18.1507 11.906 18.5302C12.1265 18.9098 12.4276 19.2363 12.788 19.4868C13.1485 19.7373 13.5595 19.9056 13.9921 19.98C14.4247 20.0543 14.8683 20.0328 15.2917 19.917C15.715 19.8012 16.1078 19.5939 16.4424 19.3097C16.7769 19.0255 17.045 18.6714 17.2277 18.2723C17.4105 17.8732 17.5034 17.4389 17.5 17C17.4981 16.4834 17.3602 15.9764 17.1 15.53C17.5276 15.2604 17.8802 14.8871 18.1249 14.4448C18.3697 14.0025 18.4987 13.5055 18.5 13ZM14.59 10H6L4.34 4.00001H16.2L14.59 10ZM6.5 18C6.30222 18 6.10888 17.9414 5.94443 17.8315C5.77998 17.7216 5.65181 17.5654 5.57612 17.3827C5.50043 17.2 5.48063 16.9989 5.51921 16.8049C5.5578 16.6109 5.65304 16.4328 5.79289 16.2929C5.93275 16.153 6.11093 16.0578 6.30491 16.0192C6.49889 15.9806 6.69996 16.0004 6.88268 16.0761C7.06541 16.1518 7.22159 16.28 7.33147 16.4444C7.44135 16.6089 7.5 16.8022 7.5 17C7.5 17.2652 7.39464 17.5196 7.20711 17.7071C7.01957 17.8947 6.76522 18 6.5 18ZM14.5 18C14.3022 18 14.1089 17.9414 13.9444 17.8315C13.78 17.7216 13.6518 17.5654 13.5761 17.3827C13.5004 17.2 13.4806 16.9989 13.5192 16.8049C13.5578 16.6109 13.653 16.4328 13.7929 16.2929C13.9327 16.153 14.1109 16.0578 14.3049 16.0192C14.4989 15.9806 14.7 16.0004 14.8827 16.0761C15.0654 16.1518 15.2216 16.28 15.3315 16.4444C15.4414 16.6089 15.5 16.8022 15.5 17C15.5 17.2652 15.3946 17.5196 15.2071 17.7071C15.0196 17.8947 14.7652 18 14.5 18Z"
                      fill="#6e686e"
                    />
                  </svg>
                </a>
              </Link>
            </div>
            <ul className="flex-none">
              {getCookie(`${TYPE_CONSTANT.DOMAIN}_login`) ? (
                <HeaderProfile5 />
              ) : (
                <Link href={`/sign-in?to=${router.asPath}`}>
                  <a className="font-medium  text-gray-800 hover:text-primary px-5 py-3 flex items-center transition duration-150 ease-in-out">
                    {Menubar_text.more.signin_signup}
                  </a>
                </Link>
              )}
            </ul>
          </div>

          {/* Mobile menu */}
          <div className="flex md:hidden gap-3">
            <ul>
              <CustomSearchBox />
            </ul>
            <div className="flex-none">
              <Notifications4 />
            </div>
            <ul>
              <HeaderProfile />
            </ul>
            {/* Hamburger button */}
            <button
              ref={trigger}
              className={`hamburger ${mobileNavOpen && 'active'}`}
              aria-controls="mobile-nav"
              aria-expanded={mobileNavOpen}
              onClick={() => setMobileNavOpen(!mobileNavOpen)}
            >
              <span className="sr-only">Menu</span>
              <svg
                className={[
                  'w-6 h-6 fill-current text-primary',
                  mobileNavOpen
                    ? 'hidden  opacity-0 duration-300 transition-all'
                    : 'block opacity-100 duration-300 transition-all',
                ].join(' ')}
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y="4" width="24" height="2" />
                <rect y="11" width="24" height="2" />
                <rect y="18" width="24" height="2" />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className={[
                  'w-6 h-6 text-primary ',
                  mobileNavOpen
                    ? 'block opacity-100 duration-300 transition-all'
                    : 'hidden  opacity-0 duration-300 transition-all',
                ].join(' ')}
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            {/*Mobile navigation */}
            <div ref={mobileNav}>
              <Transition
                show={mobileNavOpen}
                tag="nav"
                id="mobile-nav"
                className="absolute top-full h-screen pb-16 z-20 left-0 w-full overflow-scroll bg-white"
                enter="transition ease-out duration-200 transform"
                enterStart="opacity-0 -translate-y-2"
                enterEnd="opacity-100 translate-y-0"
                leave="transition ease-out duration-200"
                leaveStart="opacity-100"
                leaveEnd="opacity-0"
              >
                <ul className="px-5 py-2">
                  <li>
                    <Link
                      href={{
                        pathname: '/l',
                      }}
                      passHref
                    >
                      <a className="flex text-gray-800 hover:text-primary py-2">
                        {Menubar_text.more.all_listings}
                      </a>
                    </Link>
                  </li>

                  {TYPE_CONSTANT.MARKETPLACE_FLAVOURS === 1 && (
                    <li>
                      <Link
                        href={{
                          pathname: '/a',
                        }}
                        passHref
                      >
                        <a className="flex text-gray-800 hover:text-primary py-2">
                          {Menubar_text.more.all_accounts}
                        </a>
                      </Link>
                    </li>
                  )}

                  <li className="py-2 my-2 border-t border-b border-gray-200">
                    <span className="flex text-gray-800 hover:text-primary py-2">
                      {Menubar_text.more.categories}
                    </span>
                    <ul className="pl-4">
                      {all_categories?.map((item, index, array) => {
                        return (
                          <li key={index}>
                            <Link
                              href={{
                                pathname: `/lc/[slug]`,
                                query: {
                                  slug: item.slug
                                    ? item.slug
                                    : `${item?.id}-${SlugChecker(item.name)}`,
                                },
                              }}
                            >
                              <a className="text-sm flex font-medium text-gray-800 hover:text-primary py-2">
                                {item.name.length > 20
                                  ? item.name.substring(0, 19) + '.'
                                  : item.name}
                              </a>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                  {!login && (
                    <>
                      <li>
                        <Link href={`/sign-in?to=${router.asPath}`}>
                          <a className="flex font-medium w-full text-gray-800 hover:text-primary py-2 justify-center">
                            {Menubar_text.more.signin_signup}
                          </a>
                        </Link>
                      </li>
                    </>
                  )}
                </ul>
              </Transition>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header12;
